import {NgModule} from '@angular/core';
import {AppConstants} from '../AppConstants';
import {BrowserModule} from '@angular/platform-browser';
import {ShellComponent, ShellModule, ShellOptions} from '@edifecs/fp-ui-shell';
import {SelectModule} from 'primeng/select';
import {PipesModule} from '@edifecs/fp-ui-lib';
import {NavLinksProviderService} from '@app/core/services/NavLinksProviderService';
import {RoutesProviderService} from '@app/core/services/RoutesProviderService';
import {InitializerService} from '@app/core/services/InitializerService';
// import {
//     NavFooterModule,
//     NavHeaderModule,
//     UMP_APP_INIT,
//     UMP_CONFIG_TOKEN,
//     UMP_HTTP_INTERCEPTOR,
//     UmpConfig,
//     UmpDataService
// } from '@edifecs/ump-ui-lib';
// import {WrapperUmpComponent} from '@app/core/components/wrapper-ump/wrapper-ump.component';
// import {WrapperUmpFooterComponent} from '@app/core/components/wrapper-ump-footer/wrapper-ump-footer.component';
import {AppInfoComponent} from '@app/core/components/AppInfoComponent';
import {SubtenantListComponent} from '@app/core/components/SubtenantListComponent';
import {SubtenantErrorComponent} from '@app/core/components/SubtenantErrorComponent';
import {EnvNavLinkComponent} from '@app/core/components/EnvNavLinkComponent';
import {EnvListComponent} from '@app/core/components/EnvListComponent';
import {AppConfigService} from '@app/core/services/AppConfigService';
import {EnvService} from '@app/core/services/EnvService';
import {SubtenantService} from '@app/core/services/SubtenantService';
import {SideNavDefaultsService} from '@app/core/services/SideNavDefaultsService';
import {ActionBarDefaultsService} from '@app/core/services/ActionBarDefaultsService';
// import {BootstrapService} from '@app/core/services/BootstrapService';
import {
    EDF_SETTINGS_CONFIG_TOKEN,
    EDF_SIDE_BAR_SETTINGS,
    EdfIconModule,
    EdfSettingsModule,
    EdfSettingsService
} from '@edfx/edifecs-ui-lib';
import {edfIcons} from '@edfx/edf-icons';
import {map} from 'rxjs';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { appPreset } from '../../app.primeng-preset';
import { ConsentInterceptor } from '@app/member/dashboard/consent/services/consent.interceptor';

// const UMP_CONFIG: UmpConfig = {
//     urlPrefix: AppConstants.UMP_BASE_URL,
//     appId: AppConstants.COLLABLYNK_SERVICE_ID,
//     fromUmp: false
// };

// imports
const AUTH_TYPE = AppConstants.CMFA_MODE ? 'cmfa' : 'fpp';
const SHELL_OPTIONS: ShellOptions = {
    // auth config
    authConfig: {
        // auth type
        type: AppConstants.SKIP_AS_AUTH ? 'none' : AUTH_TYPE,

        // keycloak specific
        keycloakConfig: {
            url: AppConstants.COLLABLYNK_AUTH_URL,
            realm: AppConstants.COLLABLYNK_AUTH_REALM,
            clientId: AppConstants.COLLABLYNK_UI_CLIENT_ID
        },
        accountServiceAppId: AppConstants.COLLABLYNK_APP_ID
    },

    // provide nav links
    navLinksProvider: NavLinksProviderService,

    // provide app routes
    routesProvider: RoutesProviderService,

    // initialization
    serviceInitializer: InitializerService,

    // nav link handling
    navLinkInterceptor: NavLinksProviderService,

    // settings enabled
    isSettingsEnabled: true
};

/**
 * Root (bootstrap) module for the application. Must not be imported into any other app modules.
 */
@NgModule({

    // imports shell module and dependencies
    imports: [BrowserModule, ShellModule.withOptions(SHELL_OPTIONS), SelectModule, PipesModule,
        EdfSettingsModule, EdfIconModule.withIcons(...edfIcons),
        // NavHeaderModule, NavFooterModule
    ],

    // components
    declarations: [AppInfoComponent, SubtenantListComponent, SubtenantErrorComponent,
        EnvNavLinkComponent, EnvListComponent,
        // WrapperUmpComponent, WrapperUmpFooterComponent
    ],

    // providers
    providers: [InitializerService, AppConfigService, NavLinksProviderService, RoutesProviderService, EnvService,
        EnvService.INTERCEPTOR_PROVIDER, SubtenantService, SubtenantService.INTERCEPTOR_PROVIDER,
        SideNavDefaultsService, SideNavDefaultsService.BASE_PROVIDER, ActionBarDefaultsService,
        ActionBarDefaultsService.BASE_PROVIDER,
        // UmpDataService,
        // AppConstants.CMFA_MODE ? UMP_APP_INIT : [],
        // AppConstants.CMFA_MODE ? UMP_HTTP_INTERCEPTOR : [],
        // {provide: UMP_CONFIG_TOKEN, useValue: UMP_CONFIG},
        // BootstrapService.INTERCEPTOR,
        ConsentInterceptor.INTERCEPTOR_PROVIDER,
        {
            provide: EDF_SETTINGS_CONFIG_TOKEN,
            useValue: {
                helpUrl: AppConstants.HELP_SERVICE_URL,
                settingsUrl: '/api/main/config/settings'
            }
        },
        {
            provide: EDF_SIDE_BAR_SETTINGS,
            deps: [EdfSettingsService, AppConfigService],
            useFactory: (srv: EdfSettingsService, config: AppConfigService) => srv.settings.pipe(
                map(() => ({
                    colorThemeData: config.sideNavUiConfig,
                    helpServiceUrl: AppConstants.HELP_SERVICE_URL,
                    accountServiceUrl: AppConstants.COLLABLYNK_AUTH_BASE_URL,
                    expandByHover: false
                }))
            )
        },
        // Primeng Theme Preset: https://primeng.org/configuration
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: appPreset,
                options: {
                    darkModeSelector: false
                }
            }
        })
    ],

    // bootstrap shell component
    bootstrap: [ShellComponent,
        // WrapperUmpComponent, WrapperUmpFooterComponent
    ]
})
export class CoreModule {
}
